import React from "react";
import { SnackbarContent, CustomContentProps } from "notistack";
import { Check } from "lucide-react";

const CustomSuccessSnackbar = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {
  const { message, id, action, ...other } = props;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <SnackbarContent
        ref={ref}
        id={id?.toString()}
        {...other}
        style={{
          backgroundColor: "white",
          color: "black",
          padding: "16px 20px",
          fontSize: "1rem",
          fontWeight: "500",
          lineHeight: "1.5",
          fontFamily: "var(--font-sans)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          position: "relative",
          width: "fit-content",
          minWidth: "unset",
          maxWidth: "unset",
        }}
      >
        <div
          className="bg-brand"
          style={{
            color: "white",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            fontWeight: "bold",
            marginRight: "12px",
            animation: "iconBounce 0.6s ease-out",
          }}
        >
          <Check size={16} />
        </div>
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          <span style={{ flex: 1, whiteSpace: "nowrap" }}>{message}</span>
          {action && (
            <span style={{ flexShrink: 0 }}>
              {typeof action === "function" ? action(id) : action}
            </span>
          )}
        </div>
      </SnackbarContent>
    </div>
  );
});

CustomSuccessSnackbar.displayName = "CustomSuccessSnackbar";

export default CustomSuccessSnackbar;
